import type { WorkflowCopy, WorkflowOptions, WorkflowPermissions } from '@/frontend/features/Praxis/WorkflowChecklist'
export type McpCopy = Record<string, string>
export interface OrganizationOption { id: string; name: string; slug: string }
export interface Pagination { page: number; total_pages: number; total: number }
export interface AccessEvent {
  id: string
  event_type: string
  actor_name: string
  created_at: string
  details: Record<string, { before: unknown; after: unknown }>
}
export interface McpAccess {
  id: string
  name: string
  mode: 'read_only' | 'read_write'
  scope_kind: 'organization' | 'project' | 'engineering'
  environment: string | null
  project_id: string | null
  project_name: string | null
  organizations: OrganizationOption[]
  organization_ids: string[]
  all_organizations: boolean
  capabilities: string[]
  all_capabilities: boolean
  created_by: string
  created_by_id: number
  last_edited_by: string | null
  expires_at: string | null
  revoked_at: string | null
  last_used_at: string | null
  lock_version: number
  can_rotate: boolean
  status: 'active' | 'expired' | 'revoked' | 'blocked'
  praxis_workflow_permissions: WorkflowPermissions
  workflow_organizations: OrganizationOption[]
  events: AccessEvent[]
}
export interface AuthorizationOptions {
  environments: string[]
  capability_groups: Array<{ name: string; actions: string[] }>
  allowed_actions: string[]
  engineering_enabled: boolean
}
export type AuthorizationValues = {
  name: string
  environment: string
  organization_ids: string[]
  all_organizations: boolean
  capabilities: string[]
  all_capabilities: boolean
  validity: string
  lock_version: number
  praxis_workflow_permissions: WorkflowPermissions
}
export interface LocalMcpProps {
  page_title: string
  copy: McpCopy
  accesses: McpAccess[]
  editing_access: McpAccess | null
  pagination: Pagination
  filters: { show_revoked: boolean }
  total_connections: number
  authorization_options: AuthorizationOptions
  organization_options: Pagination & { items: OrganizationOption[]; query: string }
  workflow_options: WorkflowOptions | null
  workflow_copy: WorkflowCopy
  issued_token: string | null
  skills: Array<{ slug: string; title: string; version: number; uri: string }>
  guide: { codex: string; claude: string } | null
}
export const mcpPath = '/cc/mcp_accesses'
export const formatDate = (value: string) => new Intl.DateTimeFormat('pt-BR', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value))

export const mcpListParams = (filters: LocalMcpProps['filters'], page: number) => ({ show_revoked: filters.show_revoked ? '1' : '0', page })
export const mcpUrl = (path: string, filters: LocalMcpProps['filters'], page: number) =>
  `${path}?${new URLSearchParams({ show_revoked: filters.show_revoked ? '1' : '0', page: String(page) })}`
